import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'font-awesome/css/font-awesome.min.css';
import { PageEditor } from './PageEditor';

class App extends React.Component {

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <PageEditor />
    );
  }
}
export default App;

